const RAIL_ID = "agents-listings-rail";
const SCROLL_STEP = 360;

function initRailControls() {
  const wrapper = document.getElementById(RAIL_ID);
  if (!wrapper) {
    return;
  }

  const scroller = wrapper.firstElementChild as HTMLElement | null;
  if (!scroller) {
    return;
  }

  const prev = document.querySelector<HTMLButtonElement>(`[data-rail-control="${RAIL_ID}-prev"]`);
  const next = document.querySelector<HTMLButtonElement>(`[data-rail-control="${RAIL_ID}-next"]`);

  prev?.addEventListener("click", () => {
    scroller.scrollBy({left: -SCROLL_STEP, behavior: "smooth"});
  });

  next?.addEventListener("click", () => {
    scroller.scrollBy({left: SCROLL_STEP, behavior: "smooth"});
  });
}

initRailControls();
